<template>
  <span
    class="video-container"
    :id="content.key"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
    }"
  >
    <span v-if="content.text" :id="`${content.key}-1`" @click.prevent="videoPlayerShow">{{ content.text }}</span>
    <img
      :id="`${content.key}-2`"
      :src="content.icon || require('@/assets/images/common/video-inline-icon.png')"
      :style="{
        width: (content.textStyle.fontSize + 'rem') || '',
        height: (content.textStyle.fontSize + 'rem') || '',
      }"
      alt=""
      class="video-icon" 
      @click.prevent="videoPlayerShow"/>
    <videoPlayer :dialogTitle="dialogTitle" :visible="dialogVisible" :video_src="content.url" @dialogClose="videoPlayerHide"></videoPlayer>
  </span>
</template>
<script>
/*
视频
*/
import videoPlayer from "../popup/videoPlayer.vue";
export default {
  name: "text-video",
  components: {
    videoPlayer
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogTitle: '播放视频',
      dialogVisible: false
    }
  },
  methods: {
    videoPlayerShow() {
      this.dialogVisible = true
    },
    videoPlayerHide() {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.video-container{
  cursor: pointer;
  color: #0482EC;
  vertical-align: baseline;
  span{
    vertical-align: baseline;
  }
  .video-icon{
    width: 26rem;
    height: 26rem;
    top: 4rem;
    position: relative;
    display: inline-block;
    vertical-align: baseline;
  }
}
</style>